/* DillySocks — Shopify-Forms-Feinschliff (Sean 10.09.2026).

   Unsere Formular-Optik setzt --form-field-border-radius auf Pillenform
   (dillysocks-tokens.css) — die Forms-App vererbt diese Variable aber
   auch an ihr Dropdown-Widget: Options-LISTE und EINTRAEGE wurden zu
   999px-Eiern, erste/letzte Eintraege an den runden Ecken abgeschnitten
   und die offene Liste wirkte vom Feld losgeloest ("huepft an die
   falsche Stelle", Kundengeschenke-Anfrageformular).

   Von aussen kommt CSS nicht in den Shadow-Root — aber der Root ist
   offen, und adoptedStyleSheets lassen sich ergaenzen. Dieses Script
   haengt pro Forms-Embed EIN zusaetzliches Stylesheet an: Dropdown-Feld
   12px, Options-Liste 12px mit overflow hidden, Eintraege 8px. Die
   Klassen der App sind gehasht (_selectToggle_12thd_25) — darum
   [class*=...]-Selektoren auf den stabilen Namensstamm. Text-Felder
   und Buttons bleiben unveraendert Pille. */
(function () {
  'use strict';

  /* Praezisierung (Sean 10.09., zweiter Anlauf): Das geschlossene
     Dropdown-FELD bleibt Pille wie die uebrigen Felder — nur das
     aufgeklappte Popup wird eckig. Das Ei malte nicht die Liste selbst,
     sondern ihr WRAPPER _dropdownContainer_ (border-radius 999px +
     overflow hidden schnitt die Eintraege ab). */
  var CSS_TEXT = [
    '[class*="_dropdownContainer_"] { border-radius: 12px !important; }',
    '[class*="_optionList_"] { border-radius: 12px !important; }',
    '[class*="_optionListItem_"] { border-radius: 8px !important; }',
    '[class*="_optionListItem_"] > div { border-radius: 8px !important; }',
  ].join('\n');

  var patched = new WeakSet();

  function patch(host) {
    if (!host || patched.has(host)) return;
    var root = host.shadowRoot;
    if (!root) return; /* naechster Beobachter-Durchlauf versucht es erneut */
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS_TEXT);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      patched.add(host);
    } catch (e) {
      /* Aeltere Browser ohne Constructable Stylesheets: <style> anhaengen */
      try {
        var st = document.createElement('style');
        st.textContent = CSS_TEXT;
        root.appendChild(st);
        patched.add(host);
      } catch (e2) { /* still — Formular funktioniert auch ungestylt */ }
    }
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(patch);
  }

  /* Die App injiziert sich spaet und kann weitere Hosts nachlegen
     (Popup-Formulare) — beobachten statt einmalig pruefen. Der Observer
     sieht nur Light-DOM-Mutationen; haengt die App den Shadow-Root erst
     NACH dem Einfuegen des Hosts an, feuert nichts mehr — darum
     zusaetzlich ein begrenzter Wiederholungs-Timer (30s). */
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    tries += 1;
    if (tries >= 37) clearInterval(timer);
  }, 800);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
